export default "__VITE_ASSET__4dcd7240__"